<template>
  <div v-show="show">
    <div class="row recursive-row table-active" >
      <div class="col-sm-10 col-md-9 ellipsis-text align-self-center">
        <indented-span :level="1">
          <button v-if="hasToggle" @click="toggleDropdown" class="badge badge-light badge-sm badge-toggle align-self-center" >
            <font-awesome-icon :icon="dropdownIcon" />
          </button>
          {{ version.version }}
        </indented-span> <active-tag class="d-md-none" :isActive="version.is_active" />
      </div>
      <active-column :isActive="version.is_active" />
      <div class="col-sm-2 text-right align-self-center" v-if="isSuperUser || isStaffUser">
        <button class="btn btn-sm" @click="selectVersion">Select</button>
      </div>
    </div>
    <download-row v-for="download in version.downloads"
      :key="download.id"
      :download="download"
      :show="showDownloads" />
  </div>
</template>

<script>
import DownloadRow from './DownloadRow.vue';
import IndentedSpan from '../IndentedSpan.vue';
import ActiveTag from '../Tags/ActiveTag.vue';
import ActiveColumn from './ActiveColumn.vue';
import config from '../../constants/config';
import { mapGetters } from 'vuex';

export default {
  components: {
    DownloadRow,
    IndentedSpan,
    ActiveTag,
    ActiveColumn
  },
  name: 'VersionRow',
  props: {
    version: Object,
    show: Boolean,
    showDownloads: Boolean
  },
  methods: {
    selectVersion() {
      this.$store.commit('product/selectVersion', this.version);
      this.$bvModal.show(config.VERSION_MODAL_ID);
    },
    toggleDropdown() {
      this.showDownloads = !this.showDownloads;
    }
  },
  computed: {
    ...mapGetters('user', ['isSuperUser', 'isStaffUser']),
    dropdownIcon() {
      return this.showDownloads ? 'angle-down' : 'angle-right';
    },
    hasToggle() {
      return this.version.downloads && this.version.downloads.length > 0;
    }
  }
};
</script>
